<script>
import { connect } from 'vuex-connect';
import GamesFilteredBox from '../scenes/GamesFilteredBox.vue';

export default connect({
  gettersToProps: {
    filteredGames: 'filteredGames',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.filteredGames,
  },
  actionsToEvents: {
    'clear-filters': 'onFiltersClear',
  },
})('GamesFilteredBox', GamesFilteredBox);
</script>
